import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const statusStyles = {
  new: "bg-red-500/15 text-red-600 border border-red-500/40",
  open: "bg-red-500/10 text-red-600 border border-red-500/30",
  assigned: "bg-indigo-500/10 text-indigo-400 border border-indigo-500/30",
  in_progress: "bg-amber-500/10 text-amber-400 border border-amber-500/30",
  pending_customer: "bg-orange-500/10 text-orange-400 border border-orange-500/30",
  pending_third_party: "bg-fuchsia-500/10 text-fuchsia-400 border border-fuchsia-500/30",
  resolved: "bg-emerald-500/10 text-emerald-400 border border-emerald-500/30",
  closed: "bg-slate-200 text-slate-600 border border-slate-200",
  cancelled: "bg-slate-200 text-slate-500 border border-slate-200 line-through",
  reopened: "bg-red-500/10 text-red-400 border border-red-500/30",
};

const statusLabel = {
  new: "New",
  open: "Open",
  assigned: "Assigned",
  in_progress: "In Progress",
  pending_customer: "Pending Customer",
  pending_third_party: "Pending 3rd Party",
  resolved: "Resolved",
  closed: "Closed",
  cancelled: "Cancelled",
  reopened: "Reopened",
};

const priorityStyles = {
  low: "bg-slate-200 text-slate-700 border border-slate-200",
  medium: "bg-red-500/10 text-red-600 border border-red-500/30",
  high: "bg-amber-400/10 text-amber-400 border border-amber-400/40",
  critical: "bg-red-500/15 text-red-400 border border-red-500/40",
};

export function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-${status}`}
      className={cn("inline-flex items-center rounded-sm px-2 py-0.5 text-[11px] font-mono uppercase tracking-wider whitespace-nowrap", statusStyles[status] || statusStyles.new)}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current mr-2 opacity-80" />
      {statusLabel[status] || status}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  return (
    <span
      data-testid={`priority-${priority}`}
      className={cn("inline-flex items-center rounded-sm px-2 py-0.5 text-[11px] font-mono uppercase tracking-wider", priorityStyles[priority] || priorityStyles.medium)}
    >
      {priority}
    </span>
  );
}

export function TicketIdBadge({ id }) {
  return (
    <Badge variant="outline" className="font-mono tracking-tight rounded-sm border-slate-200 text-slate-700 bg-transparent whitespace-nowrap">
      {id}
    </Badge>
  );
}

export const STATUS_OPTIONS = Object.keys(statusLabel);
export const STATUS_LABEL = statusLabel;
